import { cfg } from '../../config';
import dotenv from 'dotenv';

dotenv.config();

export async function getUserById(userId) {
  try {
    const response = await fetch(
      `${process.env.HOST}/${cfg.API.routes.user}/${userId}`
    );
    const data = await response.json();
    return { success: true, data: data };
  } catch (error) {
    return { success: false, data: error };
  }
}
